export type GlobalRegisterType = 'korean' | 'japanese' | 'spanish' | 'french' | 'italian' | 'american' | 'indian';
export type LocaleType = 'en' | 'es' | 'fr' | 'it' | 'ja' | 'ko';

const DEFAULT_LANGUAGE: LocaleType = 'en';

const REGISTER_TYPES_BY_LOCALE: Partial<Record<LocaleType, GlobalRegisterType>> = {
  en: 'american',
  es: 'spanish',
  fr: 'french',
  it: 'italian',
  ja: 'japanese',
  ko: 'korean',
};

const HOST_LOCALE_MAPPING: Partial<Record<string, LocaleType>> = {
  es: 'es',
  fr: 'fr',
  it: 'it',
  jp: 'ja',
  kr: 'ko',
};

export const getRegisterTypeByLocale = (locale: LocaleType): GlobalRegisterType | null => {
  return REGISTER_TYPES_BY_LOCALE[locale] || null;
};

export const getRegisterTypeByIdentity = (_host: string, locale: LocaleType): GlobalRegisterType | null =>
  getRegisterTypeByLocale(locale);

export const getLanguageCodeByHost = (host: string): LocaleType => {
  const subdomain = host?.split('.')?.[0];

  if (subdomain === 'www' || subdomain === 'benzinga') {
    return DEFAULT_LANGUAGE;
  }

  return HOST_LOCALE_MAPPING[subdomain] ?? DEFAULT_LANGUAGE;
};
